var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "stream-content" }, [
    _c("textarea", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.editableContent,
          expression: "editableContent",
        },
      ],
      staticClass: "form-text stream-content__value",
      domProps: { value: _vm.editableContent },
      on: {
        input: function ($event) {
          if ($event.target.composing) return
          _vm.editableContent = $event.target.value
        },
      },
    }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "stream-content__save" },
      [
        _c(
          "button",
          {
            staticClass: "btn btn-primary",
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.updateContent.apply(null, arguments)
              },
            },
          },
          [_vm._v("Сохранить контент")]
        ),
        _vm._v(" "),
        _c("transition", { attrs: { name: "fade-out" } }, [
          _vm.saveAnimation ? _c("div", [_vm._v("Сохранено..")]) : _vm._e(),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }